import React from 'react'
import styled from 'styled-components'
import { useGlobalLabels } from '@sentecacommerce-theme/lib'

const LOGIN_CONST = 'Login'
const REGISTER_CONST = 'Register'

const Headers = ({
  active,
  setActive,
}: {
  active: string
  setActive: (data: string) => void
}) => {
  const labels = useGlobalLabels()
  return (
    <Container>
      <Wrapper className="pb-4">
        <Header onClick={() => setActive(LOGIN_CONST)}>
          <HeaderSpan className="pb-4" isActive={active === LOGIN_CONST}>
            {labels?.logIn}
          </HeaderSpan>
        </Header>
        <Header onClick={() => setActive(REGISTER_CONST)}>
          <HeaderSpan className="pb-4" isActive={active === REGISTER_CONST}>
            {labels?.register?.label}
          </HeaderSpan>
        </Header>
      </Wrapper>
    </Container>
  )
}

export { Headers }

const Container = styled.div`
  margin-top: 1.2rem;
  margin-bottom: 2.4rem;
`

const Wrapper = styled.div`
  display: flex;
  color: ${({ theme }) => theme.palette.surfCrest};
  text-align: center;
  font-size: 1.7rem;
  font-weight: 600;
`

const Header = styled.div`
  flex: 50%;
  cursor: pointer;
`

interface IsActivatable {
  isActive: boolean
}

const HeaderSpan = styled.span<IsActivatable>`
  ${(props) =>
    props.isActive &&
    `
  border-bottom: solid ${props.theme.palette.silverTree};
  color: ${props.theme.palette.silverTree};
  transition: all .2s;
  `}
`
